/* eslint-disable */

import { checkIsMobile } from '../platformUtils';
import { isCrefitApp, isDev, isEkycWebview, isProduction } from '../util';
import { crefitNative } from './crefit';
import { NativeApi, Platform } from './interface';
import { mobileWebClient } from './mobileWebClient';
import { mylink } from './mylink';
import { pcWebClient } from './pcWebClient';

const devDefaultClient = crefitNative;

const isMylink = () => navigator.userAgent.indexOf('hshhk') > -1;

/**
 * 使用 Proxy 封装 nativeApi，在生产环境中限制访问
 * 1. 不可修改任何属性，包括任何方法
 * 2. 只能调用 get 开头的方法，其他的一律不许
 * @param api nativeApi 对象
 * @returns 封装后的 nativeApi
 
 */
const createProtectedNativeApi = (api: NativeApi): NativeApi => {
  return new Proxy(api, {
    // 阻止所有属性设置
    set(target, prop, value) {
      console.warn(`[NativeApi] 生产环境禁止修改属性: ${String(prop)}`);
      return false;
    },
    // 阻止属性删除
    deleteProperty(target, prop) {
      console.warn(`[NativeApi] 生产环境禁止删除属性: ${String(prop)}`);
      return false;
    },
    // 阻止属性定义
    defineProperty(target, prop, descriptor) {
      console.warn(`[NativeApi] 生产环境禁止定义属性: ${String(prop)}`);
      return false;
    },
    // 控制方法调用
    get(target, prop) {
      const value = target[prop as keyof NativeApi];

      // 如果是函数且不是以 get 开头，返回一个抛出错误的函数
      if (typeof value === 'function' && !String(prop).startsWith('get')) {
        return () => {
          throw new Error(`[NativeApi] 生产环境禁止调用非 get 开头的方法: ${String(prop)}`);
        };
      }

      // 其他情况正常返回
      return value;
    },
  });
};

export const getNativeClient = () => {
  let nativeApi: NativeApi = mobileWebClient;
  switch (true) {
    case isMylink():
      nativeApi = mylink;
      break;
    case isCrefitApp():
      nativeApi = crefitNative;
      break;
    case isEkycWebview():
      nativeApi = mobileWebClient;
      nativeApi.name = Platform.EkycWebview;
      break;
    case checkIsMobile():
      // 移动端web
      nativeApi = mobileWebClient;
      break;
    default:
      // 普通web H5页面
      nativeApi = isDev() ? devDefaultClient : pcWebClient;
      break;
  }
  return isDev() ? devDefaultClient : nativeApi;
};

export let nativeApi = getNativeClient();

setTimeout(() => {
  nativeApi = getNativeClient();

  // 生产环境使用 Proxy 封装，开发和测试环境直接赋值
  window.nativeApi = isProduction()
    ? createProtectedNativeApi({ ...nativeApi, env: 'hk' })
    : { ...nativeApi, env: 'dev-hk' };
}, 500);
